document.addEventListener('DOMContentLoaded', function () {
	function timestamp() {
		const response = document.getElementById('g-recaptcha-response');
		if (response === null || response.value.trim() === '') {
			const captchaSettingsElement = document.getElementsByName('captcha_settings')[0];
			if (captchaSettingsElement) {
				const elems = JSON.parse(captchaSettingsElement.value);
				elems['ts'] = JSON.stringify(new Date().getTime());
				captchaSettingsElement.value = JSON.stringify(elems);
			}
		}
	}

	function validateRecaptcha(event) {
		const response = document.getElementById('g-recaptcha-response');
		const errorBanner = document.getElementById('salesforce-error-message');
		if (response === null || response.value.trim() === '') {
			errorBanner.style.display = 'block';
			event.preventDefault(); // Prevent form submission
		} else {
			errorBanner.style.display = 'none'; // Hide error banner if reCAPTCHA is completed
		}
	}

	window.onRecaptchaSuccess = function () {
		const submitButton = document.getElementById('salesforce-submit-button');
		submitButton.disabled = false;
		document.getElementById('salesforce-error-message').style.display = 'none';
	}; 

	window.onRecaptchaExpired = function () {
		const submitButton = document.getElementById('salesforce-submit-button');
		submitButton.disabled = true; // Disable the submit button
	};

	const form = document.getElementById('salesforce-form');
	if (form) {
		form.addEventListener('submit', validateRecaptcha);
		// eslint-disable-next-line no-magic-numbers
		setInterval(timestamp, 500);
	}
});
